module.exports = {
    tel: /^\+?(?:([\s()-])*\d\1?){10,12}/,
    vin: /^[0-9A-HJ-NPR-Z]{8,}$/
};
